export type SyllabusRequest = {
  slug: string
  email: string
}

export const submitSyllabusRequest = async (
  request: SyllabusRequest,
): Promise<SyllabusRequest> => request
